import { render, staticRenderFns } from "./RxdSwitch.vue?vue&type=template&id=62dbee79&scoped=true&"
import script from "./RxdSwitch.vue?vue&type=script&lang=ts&"
export * from "./RxdSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./RxdSwitch.vue?vue&type=style&index=0&id=62dbee79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dbee79",
  null
  
)

export default component.exports